import React from 'react';
import { useCssHandles } from '../../../../utils/functions';

const CSS_HANDLES = [
	'filter__container',
	'filterTitle',
	'filterTitleSpan',
	'filterTemplateOverflow',
	'filterAvailable',
];
const FilterPrice = () => {
	const { handles, withModifiers }: any = useCssHandles(`vtex-search-result-3-x-`, CSS_HANDLES);
	const priceRange = withModifiers('filter__container', 'priceRange');
	return (
		<div className={`${priceRange} bb b--muted-4`}>
			<div className={`${handles.filter} ${handles.filterAvailable} pv5 `}>
				<div role="button" className="" aria-disabled="true">
					<div className={`${handles.filterTitle} flex items-center justify-between`}>
						<span className={`${handles.filterTitleSpan}`}>Faixa de Preço</span>
					</div>
				</div>
			</div>
			<div
				className={`${handles.filterTemplateOverflow} pb5`}
				data-testid="scrollable-element"
				aria-hidden="true"
				style={{ maxHeight: '200px' }}
			>
				<div className="vtex-slider-container">
					<div className="vtex-slider w-100 relative pointer" style={{ height: '24px' }}>
						<div
							className="vtex-slider__base w-100 bg-muted-4 absolute br-pill overflow-hidden"
							style={{ height: '0.25rem', top: '0.7rem' }}
						>
							<div
								className="vtex-slider__base-internal absolute h-100 bg-action-primary"
								style={{ left: '0px', right: '0px' }}
							>
								<div
									className="vtex-slider__base-internal absolute h-100 bg-action-primary"
									style={{ left: '0px', right: '105.669px' }}
								></div>
							</div>
						</div>
						<div
							className="vtex-slider__selector-container absolute pointer z-1 left-0"
							style={{ transform: 'translateX(0px) translateX(-50%)', top: '6.5px' }}
						>
							<div
								className="vtex-slider__selector br-100 bg-action-primary flex justify-center items-center"
								style={{
									height: '0.75rem',
									width: '0.75rem',
									boxShadow: 'rgba(0, 0, 0, 0.15) -1px 1px 3px',
								}}
							></div>
						</div>
						<div
							className="vtex-slider__selector-container absolute pointer z-1 right-0"
							style={{
								transform: 'translateX(0px) translateX(50%)',
								willChange: 'transform',
								top: '6.5px',
							}}
						>
							<div
								className="vtex-slider__selector br-100 bg-action-primary flex justify-center items-center"
								style={{
									height: '0.75rem',
									width: '0.75rem',
									boxShadow: 'rgba(0, 0, 0, 0.15) -1px 1px 3px',
								}}
							></div>
						</div>
					</div>
					<div className="vtex-slider__values-container flex justify-end">
						<label className="vtex-slider__left-value t-small c-muted-1">R$&nbsp;5,00</label>
						<label className="vtex-slider__right-value t-small c-muted-1">
							<span className="vtex-slider__dash mh2">–</span>R$&nbsp;100,00
						</label>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FilterPrice;
